import { OnboardingLayout } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H1, H2 } from "@components/Typography";
import { Translations, i18n } from "@i18n";
import { styles } from "./styles";

export const NotFoundRoute = () => {
  return (
    <OnboardingLayout>
      <H1 style={styles.heading}>{i18n.t(Translations.NotFoundRouteHeader)}</H1>

      <H2 style={styles.text}>{i18n.t(Translations.NotFoundRouteTitle)}</H2>
      <Spacing size={SpacingSizes.M} />

      <Body style={styles.text}>{i18n.t(Translations.NotFoundRouteSubtitle)}</Body>
      <Spacing size={SpacingSizes.XXXL} />
    </OnboardingLayout>
  );
};
